import {
	Directive,
	HostListener,
	Input,
	ElementRef,
	HostBinding,
	Renderer2,
	AfterViewInit
} from "@angular/core";

@Directive({
    selector: "[stickAt]",
    standalone: false
})
export class StickAtDirective implements AfterViewInit {
	private __element: HTMLElement;
	private __elementPosition: number;
	private __elementHeight: number;
	private __nextSibling: HTMLElement;

	@HostBinding("style.top.px")
	@Input()
	stickAt = 0;

	@HostListener("window:scroll", ["$event"])
	onScroll() {
		if (window.pageYOffset + this.stickAt > this.__elementPosition) {
			this.__element.classList.add("stick");
			if (this.__nextSibling) {
				this.__nextSibling.style.marginTop = `${
					this.__elementHeight
				}px`;
			}
		} else {
			this.__element.classList.remove("stick");
			if (this.__nextSibling) {
				this.__nextSibling.style.marginTop = `0`;
			}
		}
	}

	constructor(er: ElementRef, private __renderer: Renderer2) {
		this.__element = er.nativeElement;
	}

	ngAfterViewInit() {
		this.__elementPosition = this.__element.offsetTop;
		this.__elementHeight = this.__element.offsetHeight;
		this.__nextSibling = <HTMLElement>this.__element.nextElementSibling;
	}
}
